<script setup lang="ts">
import { RouterLink, RouterView } from 'vue-router';
</script>

<template>
    <main class="ktg-main-container">
        <h1 class="ktg-title-01 mb-3rem">{{ $t('planungsgeschaefte') }}</h1>
        <nav class="mb-0_5rem">
            <ktg-tabs>
                <RouterLink :to="{ name: 'planungsgeschaefte-overview' }" custom v-slot="{ isExactActive, navigate }">
                    <ktg-tab :active="isExactActive || null" @activate="navigate">{{ $t('overview') }}</ktg-tab>
                </RouterLink>
                <RouterLink :to="{ name: 'planungsgeschaefte-my-geschaefte' }" custom v-slot="{ isActive, navigate }">
                    <ktg-tab :active="isActive || null" @activate="navigate">{{ $t('meine_geschaefte') }}</ktg-tab>
                </RouterLink>
            </ktg-tabs>
        </nav>
        <RouterView></RouterView>
    </main>
</template>
